import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ISensor } from "../models/sensor";
import { ISearch } from "../models/inteface";

/**
 * Service class to handle data and http request related to Sensors APIs.
 */
@Injectable({
  providedIn: "root",
})
export class SensorService {
  sessionId: string = "";
  constructor(private http: HttpClient) {}

  /**
   * Method to create a new sensor.
   * @param sensor
   */
  create(sensor: ISensor) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/create`;
    return this.http.post<ISensor>(url, sensor,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  });
  }

  /**
   * Method to get data of a sensor.
   * @param sensorIdentifier
   */
  get(sensorIdentifier: string) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/get?sensor_identifier=${sensorIdentifier}`;
    return this.http.get<ISensor>(url,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  });
  }

  /**
   * Method to get data of all the sensors available.
   */
  getAllSensors(){
    const user = sessionStorage.getItem('user');
    const isGCCLogin = sessionStorage.getItem('isGCCLogin');
    const userName =  window.location.href.includes("nielit") ? sessionStorage.getItem('nielitUser') : JSON.parse(user)?.username;
    this.sessionId = localStorage.getItem('sessionId');
    const isLms = !!(sessionStorage.getItem('app_id') && sessionStorage.getItem('app_context') && sessionStorage.getItem('app_type') && sessionStorage.getItem('JWTToken'));
    const url = `${environment.apiURL}/admin/sensor/${isLms ? "get-sensors-list-lms" : "get-sensors-list"}`;
    return this.http.get(url,
      {
        headers: { 
          'cookie-header': `${this.sessionId}:${userName}`,
          'gcc-login': `${isGCCLogin}`,
          ...(isLms && {'x-api-key': isLms ? sessionStorage.getItem('JWTToken') : ''} )
        }
    })
  }

  /**
   * Method to update data of a sensor.
   * @param sensorIdentifier
   * @param updates
   */
  update(sensorIdentifier: string, updates?: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/update?sensor_identifier=${sensorIdentifier}`;
    return this.http.put<ISensor>(url,  updates,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  } );
  }

  updateV2(sensorIdentifier: string, updates?: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/v2/update?sensor_identifier=${sensorIdentifier}`;
    return this.http.put<ISensor>(url,  updates,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  } );
  }
  /**
   * Method to search a sensor.
   * @param payload
   */
  search(payload: ISearch) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/search`;
    return this.http.post<{}>(url, payload,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  });
  }

  /**
   * Method to delete a sensor.
   * @param sensorID
   */
  deleteSensor(sensorId:string){
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/delete?sensor_identifier=${sensorId}`;
    return this.http.delete(url,{
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  });
  }

  /**
   * Method to get block script for a sensor.
   * @param sensorIdentifier
   */
  getBlockScripts(sensorIdentifier: string[]) {
    const url = `${environment.apiURL}/admin/sensor/get-block-script`;
    return this.http.post<{}>(url, sensorIdentifier);
  }

  getAllLocalSensors() {
    let ts = Date.now();
    return this.http.get<{}>(`/assets/json/sensor-list-v2.json?ts=${ts}`);
  }

  findSensor(payload: any) {
    const user = sessionStorage.getItem('user');
    const userName = JSON.parse(user).username;
    this.sessionId = localStorage.getItem('sessionId');
    const url = `${environment.apiURL}/admin/sensor/find-sensor`;
    return this.http.post(url, payload, {
      headers: { 'cookie-header': `${this.sessionId}:${userName}`}
  });
  }
}
